<template src="./index.html"></template>
<script>
import minhead from '../../../common/minHead/index.vue';
import uploadfile from '../../../common/uploadFile/index.vue';
import config from '../../../../../configHttp.js';
import { getdata } from './data.js';
import { groupList, DeptChildrenUser, save, roleall, optiondelete, flieUser, userupdate} from '../../../../api/personnel.js';
import {syncUser} from '../../../../api/workManuscript'
export default {
	name: 'member',
	components: {
		minhead,
		uploadfile
	},
	data: function() {
		return {
			change: '',
			radio: '',
			tablekey: 0,
			config:config,
			headData: getdata().headData,
			tableData: getdata().tableData,
			pagination: getdata().pagination,
			formlist: getdata().formlist,
			formdata: getdata().formdata,
			formlistup:getdata().formlistup,
			formdataup:getdata().formdataup,
			headtitle: getdata().headtitle,
			activedata: [{}, {}],
			data: [],
			option: '',
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			activeNames: '',
			choosetreeid: '',
			shaidiag: false,
			memberdiag: false,
			nodediag: false,
			chooseindex: 0,
			filediag: false,
			openid: '',
			codegoole: '',
			activeSearch: '',
			carename: '',
			list_gsid:{},
			treeid: '',
			radio1: 0,
			addopen:false,
			allowDrag: null,
			upformdata: {},
			title: '',
			allowDrop: null,
			outlist: []
		};
	},
	mounted() {},
	created() {
		this.getList();
		this.getroleall();
	},

	methods: {
		nodediagset(){
				this.nodediag=true
				this.foks(this.formdataup)
		},
		handleChange(e) {
			if (this.activedata[e].type == 1) {
				this.activeNames = null;
			}
		},
		fordownloadmb() {
			//下载文件
			// window.open(config.baseURL + "sys/downloadUserTemplate", "_blank")
			let times = new Date();
			let obj = {
				YY: times.getFullYear(), //年,
				MM: times.getMonth() + 1, //月,
				DD: times.getDate(), //日,
				hh: times.getHours(),
				mm: times.getMinutes(),
				ss: times.getSeconds()
			};
			let data = obj.YY + '-' + obj.MM + '-' + obj.DD + ' ' + obj.hh + '-' + obj.mm + '-' + obj.ss;
			let params = {
				downUrl: config.baseURL + 'sys/downloadUserTemplate',
				typeObj: {
					toForm: false,
					fileType: 'xlsx',
					fileName: `进项增值税标准模板+${data}`,
					failUrl:this.$winURl
				}
			};
			this.$downloadcommon(params);
		},
		qiehome(e) {
			this.chooseindex = e;
			if (this.addopen) {
				this.foks(this.formdata);
			}else{
				this.foks(this.formdataup);
			}
		},
		getroleall(e) {
			return new Promise((resolve, reject) => {
				let params = {
					type: '1'
				};
				roleall(params).then(res => {
					if (res.data.code == 1) {
						this.activedata = res.data.data;
						this.foks(this.activedata)
						resolve(true);
					} else {
						this.$message.error(res.data.msg);
					}
				});
			});
		},
		deleteto() {
			let table = this.$refs.tablebox.getSelectionval();
			if (this.$emptyandnull(table)) {
				this.$message.error('请选择您要删除的数据');
				return false;
			}
			let params = [];
			table.map(item => {
				params.push(item.userId);
			});
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					optiondelete(params).then(res => {
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.pagination.pageNum = 1;
							this.pagination.paginationkey++;
							this.ChildrenUser();
						} else {
							this.$message.error(res.data.msg);
						}
					});
				}
			});
		},
		getdataup(){
			if(!this.formlist[0].istosee){
				this.editsubmit();
			} else {
				this.memberdiag = false;
			}
		},
		getdata() {
			this.newsubmission();
		},
		// 判断一个值是不是数组
		isArray(val) {
			return Object.prototype.toString.call(val) === '[object Array]';
			// 这里直接用Es6中的Array.isArray()方法判断是不是数组也是可以的,但是上面那种是一些标准库的常见用法
		},
		// 判断是不是对象
		isObject(val) {
			return typeof val === 'object' && val !== null;
		},
		deepCopy(obj) {
			//深拷贝对象
			var from = this.isArray(obj) ? [] : {};
			for (var property in obj) {
				if (this.isObject(obj[property])) {
					from[property] = this.deepCopy(obj[property]); // 递归
				} else {
					from[property] = obj[property];
				}
			}
			return from;
		},
		//编辑提交
		editsubmit() {
			if(this.title != '查看用户'){
					this.foks(this.activedata,1);
			let params = {
				email: this.formdataup.email,
				id: this.formdataup.userId,
				nickName: this.formdataup.nickName,
				phoneNumber: this.formdataup.phoneNumber,
				roleIds: [],
				deptId: this.treeid || this.choosetreeid,
				userStatus: this.formdataup.userStatus,
				username: this.formdataup.username
			};
			this.activedata.forEach(item => {
				if (!this.$emptyandnull(item.children)) {
					item.children.forEach(item2 => {
						if (item2.checked) {
							params.roleIds.push(item2.id);
						}
					});
				}
				if (item.checked) {
					params.roleIds.push(item.id);
				}
			});
			userupdate(params).then(res => {
				if (res.data.code == 1) {
					this.$message.success('编辑成功');
					this.ChildrenUser();
					this.memberdiag = false;
				} else {
					this.$message.error(res.data.msg);
				}
			});
			}else{
					this.memberdiag = false;

			}
			
		},
		// 新增提交
		newsubmission() {
			let from = this.deepCopy(this.formdata);
			if (from.password == '') {
				this.$message.error('密码不能为空');
				return;
			}
			if (from.password == from.passwords) {
				if(from.password.length<6||from.password.length>=30){
					return this.$message.error('密码长度最少6位最大30位')
				}
				delete from.passwords;
				delete from.userId;
				let params = {
					deptId: this.treeid || this.choosetreeid,
					...from,
					roleIds: []
				};
				this.activedata.forEach(item => {
					if (!this.$emptyandnull(item.children)) {
						item.children.forEach(item2 => {
							if (item2.checked) {
								params.roleIds.push(item2.id);
							}
						});
					}
					if (item.checked) {
						params.roleIds.push(item.id);
					}
				});
				save(params).then(res => {
					if (res.data.code == 1) {
						this.$message.success('新增成功');
						this.ChildrenUser();
						this.memberdiag = false;
					} else {
						this.$message.error(res.data.msg);
					}
				});
			} else {
				this.$message.error('两次密码不一致');
			}
		},
		foks(e,index) {
			console.log(e)
			let one = JSON.parse(JSON.stringify(this.activedata))
			if (!!e.roleNameVo) {
				e.roleNameVo.map(item=>{
					one.map(item1=>{
						if (!this.$emptyandnull(item1.children)) {
							item1.children.map(item2=>{
								if (item.roleId == item2.id) {
									item2.checked = true;
								}else{
									if(index==1){
										item2.checked = false;
									}
								}
							})
						}
					})
				})
			}
			this.activedata = JSON.parse(JSON.stringify(one))
		},
		async edit(value, index) {
			//点击查看或者编辑
			this.carename = this.list_gsid.carename
			this.choosetreeid = this.list_gsid.choosetreeid
			this.treeid= this.list_gsid.choosetreeid
			this.addopen = false
			let formlists = JSON.parse(JSON.stringify(this.formlistup))
			if (index == 1) {
				this.title = '查看用户';
				formlists.forEach(item => {
					item.istosee = true;
				});
			} else {
				this.title = '编辑用户';
				formlists.forEach(item => {
					item.istosee = false;
				});
			}
			this.chooseindex = 0;
			this.formlistup = formlists
			let one = await this.getroleall();
			if (one) {
				if (value) {
					this.formdataup = this.deepCopy(value);
					this.foks(value)
				}
				this.memberdiag = true;
				this.$refs.taxformup.clearValidate();
			}
		},
		openxin() {
			//新增按钮
			this.addopen = true
			this.title = '新增用户';
			Object.keys(this.formdata).map(key => {
				if (key != 'userStatus') {
					this.formdata[key] = '';
				} else {
					this.formdata[key] = '0';
				}
			});
			this.getroleall()
			this.qiehome('0')
			this.memberdiag = true;
			this.$refs.taxform.clearValidate();
		},
		nextoption() {
			if (this.addopen) {
				if (this.chooseindex == 1) {
					if (
						this.$emptyandnull(this.formdata.username) ||
						this.$emptyandnull(this.formdata.nickName) ||
						this.$emptyandnull(this.formdata.password) ||
						this.$emptyandnull(this.formdata.passwords)
					) {
						this.$message.error('请把信息补充完整');
					} else{
						this.$refs.taxform.submitForm();
					}
				}else{
						this.$refs.taxform.submitForm();
				}
			} else {
				if (this.chooseindex == 1) {
					if (this.$emptyandnull(this.formdataup.username) || this.$emptyandnull(this.formdataup.nickName)) {
						this.$message.error('请把信息补充完整');
					} else {
						this.$refs.taxformup.submitForm();
					}
				}else {
					this.$refs.taxformup.submitForm();
				}
			}
		},
		contnext() {
			this.treeid = JSON.parse(JSON.stringify(this.option.id));
			this.carename = JSON.parse(JSON.stringify(this.option.name));
			this.nodediag = false;
		},
		ChildrenUser() {
			let params = {
				current: this.pagination.pageNum,
				deptId: this.choosetreeid,
				size: this.pagination.pageSize,
				query: this.activeSearch //搜索框信息
			};
			DeptChildrenUser(params).then(res => {
				if (res.data.code == 1) {
					this.tableData = res.data.data.records;
					this.pagination.total = parseFloat(res.data.data.total);
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		sizechange(e) {
			//页码切换
			this.pagination.pageSize = e;
			this.ChildrenUser(); //调用分页查询
		},
		currentChange(e) {
			//页码切换
			this.pagination.pageNum = e;
			this.ChildrenUser(); //调用分页查询
		},
		clickSearch() {
			//点击搜索
			this.activeSearch = JSON.parse(JSON.stringify(this.codegoole)); //点击了搜索按钮赋值用于比对是否点击搜索
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.ChildrenUser(); //调用搜索按钮
		},
		getList() {
			groupList().then(res => {
				if (res.data.data) {
					this.data = res.data.data;
					this.choosetreeid = res.data.data[0].id;
					this.carename = res.data.data[0].name;
					// this.nodeQuery(this.data[0].id)
					this.ChildrenUser();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		forchooseitem(node, data) {
			if (!this.nodediag) {
				this.choosetreeid = data.id;
				this.carename = data.name;
				this.list_gsid = {
					choosetreeid:data.id,
					carename:data.name
				}
				this.ChildrenUser();
			}
		},
		getuploadparams(e) {
			this.upformdata = e;
		},
		filedata() {
			this.filediag = true;
			this.upformdata = {};
			this.$refs['uploadfileRef'].forrefresh();
		},
		formkm() {
			if (this.$emptyandnull(this.upformdata.upfile)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			let params = {
				file: this.upformdata.upfile
			};
			flieUser(params).then(res => {
				if (res.data.code == 1) {
					if (res.data.data.errorCount > 0) {
						this.fordowloaderr(this.upformdata.filetype, res.data.data.batchNum);
					} else {
						this.$message.success('上传成功');
					}
          this.ChildrenUser();
					this.filediag = false;
				} else {
					this.$message.error(res.data.data.msg);
				}
			});
		},

		fordowloaderr(filetype, batchNo) {
			let params = {
				downUrl: config.baseURL + '/upload-history/downloadErrorFile',
				typeObj: {
					toForm: true,
					fileType: filetype,
					failUrl:this.$winURl
				},
				params: {
					batchNo: batchNo
				}
			};
			this.$downloadcommon(params);
		},
		forback() {
			this.$router.go(-1);
		},
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
		},
		 //满帮-同步人员信息
		syncPersonnel(){
			syncUser().then(res => {
				this.ChildrenUser();
			})
		},
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
@import url('@/assets/css/tree.less');
</style>
